import React, { useEffect, useState } from 'react';
import moment from 'moment';

import Accordion from '../../../components/Accordion';
import FormContainer from '../../../components/FormContainer';
import InputInfo from '../../../components/Inputs/Info';
import { buscaDependentes } from '../../../services/beneficiario/beneficiarios';
import { useGlobal } from '../../../contexts/Global/context';
import ShortageField from './ShortageField';

import { addMaskCpf, addMaskCellphone } from '../../../utils';

import * as S from './styles';

function Dados({ dados }) {
    const [situacaoBeneficiarioDap, setSituacaoBeneficiarioDap] = useState('');
    const [dadosDependentes, setDadosDepentes] = useState([]);
    const { dataActiveContract } = useGlobal();

    useEffect(() => {
        if (dados.situacaoBeneficiario === 'APOSENTANDO' || dados.situacaoBeneficiario === 'DEMITIDO') {
            setSituacaoBeneficiarioDap('Sim');
        } else {
            setSituacaoBeneficiarioDap('Não');
        }
    }, [dados]);

    async function handleDependentes() {
        const dependentsList = await buscaDependentes(dados.numCarteirinha, dataActiveContract.numero);
        setDadosDepentes(dependentsList);
    }

    useEffect(() => {
        handleDependentes();
    }, [dados]);

    const defaultProps = {
        required: true,
    };

    const formatted = {
        centroCusto: dados.centroCusto.codigo && `${dados.centroCusto.codigo} - ${dados.centroCusto.nome}`,
        celular: dados.celular?.ddd && addMaskCellphone(`${dados.celular?.ddd}${dados.celular?.numero}`),
    };

    const enderecoResidencial =
        dados.enderecos?.length > 0 ? dados.enderecos.find((end) => end.eResidencial === true) : {};

    function renderDependentsListItem(dependent) {
        return (
            <S.ContainerCheckboxLabel key={dependent.numCarteirinha}>
                <InputInfo
                    field={{
                        id: 'nomeCompleto',
                        label: 'Nome',
                        value: `${dependent.nomeCompleto}`,
                    }}
                />
                <InputInfo
                    field={{
                        id: 'numCarteirinha',
                        label: 'Nº da carteirinha',
                        value: `${dependent.numCarteirinha}`,
                    }}
                />
                <InputInfo
                    field={{
                        id: 'grauParentesco',
                        label: 'Grau de parentesco',
                        value: `${dependent.dependencia.nome}`,
                    }}
                />
                <InputInfo
                    field={{
                        id: 'situacaoBeneficiario',
                        label: 'Status',
                        value: `${dependent.situacaoBeneficiario}`,
                    }}
                />
            </S.ContainerCheckboxLabel>
        );
    }

    return (
        <S.ContentData>
            <Accordion title="Dados para o plano" hasCollapse={false}>
                <FormContainer>
                    <InputInfo field={{ ...defaultProps, label: 'Contrato', value: dados.contrato?.nome }} />
                    <InputInfo field={{ ...defaultProps, label: 'Empresa', value: dados.empresa }} />
                    <InputInfo field={{ ...defaultProps, label: 'Plano de saúde', value: dados.planoSaude?.nome }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Data de ínicio do plano',
                            type: 'date',
                            value: dados.planoSaude?.dataInicio,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Estado de atendimento',
                            value: enderecoResidencial?.ufAtendimento,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Município de atendimento',
                            value: enderecoResidencial?.nomeMunicipioAtendimento,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Congênere',
                            value: dados.contratoCongenere?.nomeContratoCongenere,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Plano da congênere',
                            value: dados.contratoCongenere?.nomePlanoCongenere,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'N° da carteirinha congênere',
                            value: dados.contratoCongenere.numeroCarteirinhaCongenere,
                        }}
                    />
                    <InputInfo
                        field={{ ...defaultProps, label: 'N° da carteirinha saúde', value: dados.numCarteirinha }}
                    />
                    <InputInfo field={{ ...defaultProps, label: '', value: '' }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Carência do plano',
                            value: <ShortageField shortages={dados.planoSaude.carencias} />,
                        }}
                    />

                    {/* <InputInfo field={{ ...defaultProps, label: 'Plano dental', value: dados.planoDental?.nome }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Data de ínicio do plano',
                            type: 'date',
                            value: dados.planoDental?.dataInicio,
                        }}
                    />
                    <InputInfo
                        field={{ ...defaultProps, label: 'N° da carteirinha odonto', value: dados.numCarteirinha }}
                    /> */}
                </FormContainer>
            </Accordion>

            <Accordion title="Dados profissionais" hasCollapse={false}>
                <FormContainer>
                    <InputInfo field={{ ...defaultProps, label: 'Função', value: dados.funcao?.nome }} />
                    <InputInfo field={{ ...defaultProps, label: '', value: '' }} />
                    <InputInfo
                        field={{ ...defaultProps, label: 'Situação Funcional', value: dados.situacaoFuncional }}
                    />
                    <InputInfo
                        field={{ ...defaultProps, label: 'Data de admissão', type: 'date', value: dados.dataAdmissao }}
                    />
                    <InputInfo
                        field={{ ...defaultProps, label: 'Matrícula funcional', value: dados.matriculaFuncional }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Sequencial matrícula funcional',
                            value: dados.sequencialMatriculaFuncional,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Ínicio lotação',
                            type: 'date',
                            value: dados.lotacao?.dataInicio,
                        }}
                    />
                    <InputInfo field={{ ...defaultProps, label: 'Lotação', value: dados.lotacao?.nome }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Congênere',
                            value: dados.contratoCongenere?.nomeContratoCongenere,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Plano da congênere',
                            value: dados.contratoCongenere?.nomePlanoCongenere,
                        }}
                    />
                    <InputInfo field={{ ...defaultProps, label: 'Centro de custo ', value: formatted.centroCusto }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Data de início da contribuição',
                            type: 'date',
                            value: dados.dtInicioContribuicao,
                        }}
                    />
                </FormContainer>
            </Accordion>

            <Accordion title="Dados de titular" hasCollapse={false}>
                <FormContainer>
                    <InputInfo field={{ ...defaultProps, label: 'CPF', value: addMaskCpf(dados.cpf) }} />
                    <InputInfo field={{ ...defaultProps, label: 'Nacionalidade', value: dados.nacionalidade }} />
                    <InputInfo field={{ ...defaultProps, label: 'Nome completo', value: dados.nomeCompleto }} />
                    <InputInfo field={{ ...defaultProps, label: 'Nome social', value: dados.nomeSocial }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Data de nascimento',
                            type: 'date',
                            value: dados.dataNascimento,
                        }}
                    />
                    <InputInfo field={{ ...defaultProps, label: 'Sexo', value: dados.sexo }} />
                    <InputInfo field={{ ...defaultProps, label: 'Nome da mãe', value: dados.nomeMae }} />
                    <InputInfo field={{ ...defaultProps, label: 'Estado civil', value: dados.estadoCivil }} />
                    <InputInfo field={{ ...defaultProps, label: 'Nº do PIS', value: dados.numPis }} />
                    <InputInfo field={{ ...defaultProps, label: 'Nº Cartão do SUS', value: dados.numCartaoSus }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Declaração de nascido vivo (DN)',
                            value: dados.declaracaoNascVivo,
                        }}
                    />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'DAP',
                            value: situacaoBeneficiarioDap,
                        }}
                    />
                    <InputInfo field={{ ...defaultProps, label: 'Categoria', value: dados.situacaoBeneficiario }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Data do desligamento',
                            value: dados.planoSaude.dataExclusao
                                ? moment(dados.planoSaude.dataExclusao, 'DD/MM/YYYY').format('DD/MM/YYYY')
                                : '',
                        }}
                    />
                </FormContainer>
            </Accordion>
            <Accordion title="Dependentes" hasCollapse={false}>
                {dadosDependentes.map((dependent) => renderDependentsListItem(dependent))}
            </Accordion>
            <Accordion title="Dados de contato" hasCollapse={false}>
                <FormContainer>
                    <InputInfo field={{ ...defaultProps, label: 'CEP', value: enderecoResidencial?.cep }} />
                    <InputInfo field={{ ...defaultProps, label: '', value: '' }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Endereço residencial',
                            value: enderecoResidencial?.logradouro,
                        }}
                    />
                    <InputInfo field={{ ...defaultProps, label: 'Nº', value: enderecoResidencial?.numero }} />
                    <InputInfo
                        field={{
                            ...defaultProps,
                            label: 'Complemento (opcional)',
                            value: enderecoResidencial?.complemento,
                        }}
                    />
                    <InputInfo field={{ ...defaultProps, label: 'Bairro', value: enderecoResidencial?.bairro }} />
                    <InputInfo field={{ ...defaultProps, label: 'UF', value: enderecoResidencial?.estado?.codigo }} />
                    <InputInfo field={{ ...defaultProps, label: 'Cidade', value: enderecoResidencial?.cidade?.nome }} />
                    <InputInfo field={{ ...defaultProps, label: 'Telefone celular', value: formatted.celular }} />
                    <InputInfo field={{ ...defaultProps, label: 'E-mail', value: dados.email }} />
                </FormContainer>
            </Accordion>
        </S.ContentData>
    );
}

export default Dados;
